// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__KY1GH","colMin":"styles_colMin__1qNer","colCheckbox":"styles_colCheckbox__2NfP7"};